import { Control, Controller } from "react-hook-form";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Button } from "../ui/button";
import { CalendarIcon } from "lucide-react";
import { Calendar } from "../ui/calendar";
import { cn } from "@/lib/utils";
import { format } from "date-fns";
import { CreateInvoiceType } from "@/pages/Create-Invoice";

interface PickDateProps {
  control: Control<CreateInvoiceType>;
}

const PickDate = ({ control }: PickDateProps) => {
  return (
    <div className="flex items-center gap-x-1">
      <p className="font-Hemmers text-base text-black">Date:</p>
      <Controller
        name="createdAt"
        control={control}
        defaultValue={undefined}
        render={({ field }) => (
          <Popover>
            <PopoverTrigger asChild>
              <Button
                variant={"outline"}
                className={cn(
                  "bordeer ml-4 w-[196px] justify-start border border-input border-zinc-300 bg-white text-left font-normal text-zinc-900 shadow-sm hover:bg-gray-200 focus:border-zinc-500 focus:ring-zinc-500",
                  !field.value && "text-muted-foreground",
                )}
              >
                <CalendarIcon className="mr-2 h-4 w-4" />
                {field.value ? (
                  format(field.value, "PPP")
                ) : (
                  <span>Pick a date</span>
                )}
              </Button>
            </PopoverTrigger>
            <PopoverContent className="pointer-events-auto w-auto p-0">
              <Calendar
                mode="single"
                selected={field.value}
                onSelect={field.onChange}
                initialFocus
              />
            </PopoverContent>
          </Popover>
        )}
      />
    </div>
  );
};

export default PickDate;
